import { therapyPlanningAction } from '../../actions/constant';

const {
  UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_FAILURE,
  UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_SUCCESS,
  RESET_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST,
} = therapyPlanningAction;

const intitialstate: object = {
  isTherapyPlanningUpdated: false,
  response: null,
};

export const updateTherapyPlanningDischargeDateReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_SUCCESS: {
      return {
        ...state,
        isTherapyPlanningUpdated: true,
        response: action.payload,
      };
    }

    case UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_FAILURE:
      return {
        ...state,
        isTherapyPlanningUpdated: false,
        response: action.payload,
      };

    case RESET_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST:
      return intitialstate;

    default:
      return state;
  }
};
